import React from "react";
import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import { ServiceGrid } from "./ServiceGrid";
import { ClientsSection } from "./ClientsSection";
import { listServices } from "../../web/clients";

export const Servicios = () => {
  const [items, setItems] = React.useState<any | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    listServices().then((r) => setItems(r)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mt-12">
      <h1 className="text-3xl md:text-4xl font-bold text-slate-100">Servicios</h1>
      <p className="text-slate-400 mt-2 max-w-2xl">AI Agents, MCPs, ChatBots y n8n como base. Sumamos producto y delivery para acelerar resultados.</p>
      {loading && <p className="mt-10 text-slate-400">Cargando…</p>}
      {items && <ServiceGrid items={items} minimal={false} />}

      <ClientsSection className="mt-12" compact />

      <section className="mt-12 p-6 rounded-3xl border border-white/10 bg-white/5">
        <h3 className="text-xl font-semibold text-slate-100">¿No sabés por dónde empezar?</h3>
        <p className="text-slate-300 mt-2">Pedí una sesión de descubrimiento gratuita. Revisamos tu idea y te proponemos un plan.</p>
        <NavLink to="/contacto" className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-500/80 hover:bg-indigo-500 text-white">
          Agendar charla <ArrowRight className="w-4 h-4" />
        </NavLink>
      </section>
    </div>
  );
};
